(function () {
  const utils = {};
  const slate = { 
    utils: {
      /**
       * _.defaultTo from lodash
       * Checks `value` to determine whether a default value should be returned in
       * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
       * or `undefined`.
       * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
       *
       * @param {*} value - Value to check
       * @param {*} defaultValue - Default value
       * @returns {*} - Returns the resolved value
       */
      defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
      }
    }
  };

  utils.Currency = (function() {
    var moneyFormat = '${{amount}}';
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    }
  })();

  globalThis.ParcelCover = function (verbose) {
    var _state = {
        cachedCartValue: 0,
        dataSource: [],
        parcelCoverSKUS: [],
        verbose: verbose,
        miniCartObserver: null,
        lineItemObserver: null,
        coverToggle: null,
        coverEnabled: true,
        lastCoverPrice: "",
        newCoverAdded: null
      },
      // START - FEEL FREE TO EDIT SETTINGS BETWEEN THESE LINES
      _settings = {
        version: "1.0.4",
        // These should be inserted in descending order so that the appropriate cover SKU is selected
        // for specfic price brackets

        /* To get these IDs, open the desired PDP, then add a .js at the end
      (e.g. https://www.secretsneakerstore.com/products/sss-full-parcel-cover_67fezemsqwa7
      becomes https://www.secretsneakerstore.com/products/sss-full-parcel-cover_67fezemsqwa7.js).

      Look for "variants":[{"id": and copy the number right after
      */
        parcelProtectionSKUs: {
          2899.99: "40200007352454",
          2699.99: "40200007319686",
          2499.99: "40200007286918",
          2299.99: "40200006697094",
          2099.99: "40200006271110",
          1899.99: "40200005484678",
          1699.99: "39366314197126",
          1499.99: "39366313869446",
          1299.99: "39366313574534",
          1099.99: "39366313377926",
          899.99: "39366313312390",
          699.99: "39366312624262",
          499.99: "39366312034438",
          299.99: "39366312001670",
          99.99: "39366311968902",
        },
        stateKey: "ck.parcel-cover.state",
        labels: {
          hasParcelCover: "Get peace of mind with parcel cover.",
          noParcelCover:
            "By deselecting parcel cover, we are not liable for lost, damaged, or stolen items.",
        },
        defaultSubtotalHeight: 182,
      },
      // END - FEEL FREE TO EDIT SETTINGS BETWEEN THESE LINES
      __self = this;

    function debounce(func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    }

    this.getState = function () {
      return _state;
    };

    this.getSettings = function () {
      return _settings;
    };

    this.formatPrice = function (price) {
      price = price.toString();
      price = price.split("");
      const priceLength = price.length;
      price.splice(priceLength - 2, 0, ".");

      return price.join("");
    };

    this.getCart = function () {
      return new Promise((resolve, reject) => {
        const url = "/cart.js?_easygift_apply_rules=false";

        fetch(url, { 
          method: 'GET' 
        }).then((response) => {
          return resolve(response.json());
        }).then((res) => {
            if (res.status === 201) {
              console.log("Post successfully created!")
            }
        }).catch((err) => {
          return reject(err);
        });
      });
    };

    this.addToCart = function (variantId, quantity) {
      return new Promise((resolve, reject) => {
        const url = "/cart/add.js?_easygift_apply_rules=false";
        const postObj = { 
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ]
        };

        fetch(url, {
          method: 'POST',
          body: JSON.stringify(postObj),
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          }
        }).then((response) => {
          return resolve(response.json());
        }).then((res) => {
            if (res.status === 201) {
              console.log("Post successfully created!")
            }
        }).catch((err) => {
          return reject(err);
        });
      });
    };

    this.changeCart = function (variantId, quantity) {
      return new Promise((resolve, reject) => {
        // Get line_item key for the variant
        __self
          .getCart()
          .then(function (json) {
            if (!json || !json.items || !json.items.length)
              return resolve("Cart is empty!");

            let thisItem = json.items.filter((item) => {
              return item.key.includes(variantId);
            })?.[0];
            if (!thisItem) return resolve("Variant not in cart! Ignoring");

            const url = "/cart/update.js?_easygift_apply_rules=false";
            const postObj = { 
              updates: {
                [thisItem.key]: quantity,
              }
            };

            fetch(url, {
              method: 'POST',
              body: JSON.stringify(postObj),
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
              }
            }).then((response) => {
              return resolve(response.json());
            }).then((res) => {
                if (res.status === 201) {
                  console.log("Post successfully created!")
                }
            }).catch((err) => {
              return reject(err);
            });
          })
          .catch(reject);
      });
    };

    this.variantInCart = function (variantId, cart) {
      let matchingVariants = cart.items.filter(
        (item) => +item.variant_id === +variantId
      );

      return [!!matchingVariants.length, matchingVariants];
    };

    this.getCurrentCover = function (cart) {
      let parcelCoverItems = cart.items.filter((item) => {
        return _state.parcelCoverSKUS.includes(item.variant_id.toString());
      });

      return parcelCoverItems;
    };

    this.removeAllCover = function (cart = null) {
      return new Promise(function (resolve, reject) {
        if (cart) {
          let parcelCoverItems = __self.getCurrentCover(cart);

          return Promise.allSettled(
            parcelCoverItems.map((cover) =>
              __self.changeCart(cover.variant_id, 0)
            )
          )
            .then(resolve)
            .catch(reject);
        }

        Promise.allSettled(
          _state.parcelCoverSKUS.map((sku) => __self.changeCart(sku, 0))
        )
          .then(resolve)
          .catch(reject);
      });
    };

    this.manageParcelCover = function (cart) {
      return new Promise(function (resolve, reject) {
        if (!_state.coverEnabled) return resolve();

        __self.getEligibleCover(cart).then(function (parcelCoverSKU) {
          if (!parcelCoverSKU) {
            if (_state.verbose)
              console.debug(`User is not eligible for parcel cover!`);
            document.querySelector(".parcel-cover__outer-wrapper").classList.add("hide");
            return __self
              .removeAllCover(cart)
              .then(function () {
                _state.lastCoverPrice = "";
                storeState();
              })
              .then(resolve)
              .catch(reject);
          }

          document.querySelector(".parcel-cover__outer-wrapper").classList.remove("hide");

          if (_state.verbose)
            console.debug(
              "User is eligible for cover using SKU",
              parcelCoverSKU
            );

          let [variantInCart, variant] = __self.variantInCart(
            parcelCoverSKU,
            cart
          );

          var otherCoverSKUs = __self
            .getCurrentCover(cart)
            .filter((coverItem) => +coverItem.variant_id !== +parcelCoverSKU)
            .filter(function (coverItem) {
              return cart.items.find(
                (cartItem) => +cartItem.variant_id === +coverItem.variant_id
              );
            });

          Promise.allSettled(
            otherCoverSKUs.map(function (cover) {
              if (_state.verbose)
                console.debug("Removing unnecessary cover item", cover);
              return __self.changeCart(cover.variant_id, 0);
            })
          ).then(function () {
            if (variantInCart) {
              if (_state.verbose)
                console.debug(
                  "User already has this level of parcel cover in the cart!"
                );
              return __self
                .changeCart(variant[0].variant_id, 1)
                .then(resolve)
                .catch(reject);
            }
          
            return (variantInCart ? __self.changeCart : __self.addToCart)(
              parcelCoverSKU,
              1
            )
              .then(resolve)
              .catch(reject);
          });
        });
      });
    };

    this.getRealProductValue = function (
      cart,
      options = { excludeParcelCover: true, excludeNFS: true }
    ) {
      // Remove parcel cover items from cart before comparing cart value
      if (_state.verbose) console.debug("starting cart is:", cart);

      let strippedCart = { ...cart };
      strippedCart.items = cart.items.filter(function (item) {
        const isParcelCover = _state.parcelCoverSKUS.includes(
          item.variant_id.toString()
        );
        const isNFS = item.title.toUpperCase().includes("NFS");
        return (
          !(options.excludeParcelCover && isParcelCover) &&
          !(options.excludeNFS && isNFS)
        );
        // return excludeNFS ? !(isParcelCover || isNFS) : !isParcelCover;
        // return !isParcelCover && excludeNFS && !isNFS; //&& !item.handle.includes('shipping-protection');
      });

      strippedCart.item_count = strippedCart.items.length;

      strippedCart.items_subtotal_price = strippedCart.items.reduce(function (
        a,
        c
      ) {
        return a + c.final_line_price;
      },
      0);

      strippedCart.original_total_price = strippedCart.items_subtotal_price;
      strippedCart.total_price =
        strippedCart.items_subtotal_price - strippedCart.total_discount;

      if (_state.verbose) console.debug("stripped cart is:", strippedCart);
      return strippedCart;
    };

    this.silentCartUpdate = function () {
      __self
        .getCart()
        .then(function (_cart) {
          document.dispatchEvent(new Event('dispatch:cart-drawer:refresh'));

          return _cart;
        })
        .then(function (_cart) {
          let strippedCart = parcelCover.getRealProductValue(_cart, {
            excludeNFS: true,
            excludeParcelCover: false,
          });
          let moneyString = utils.Currency.formatMoney(
            strippedCart.items_subtotal_price,
            "<span class=money>${{amount}} AUD</span>"
          );
          if (document.querySelectorAll(".cart-drawer__footer .subtotal .theme-money").length) {
            document.querySelector(".cart-drawer__footer .subtotal .theme-money").innerHTML = moneyString;
          }
          
          const coverToggle = document.querySelector(".cover-toggle-track");
          coverToggle.setAttribute(
            "data-val",
            _state.coverEnabled ? _state.lastCoverPrice : ""
          );
        });
    };

    this.getEligibleCover = async function (cart = null) {
      if (cart === null) {
        cart = await __self.getCart();
      }

      let realCart = __self.getRealProductValue(cart),
        priceInDollars = +realCart.items_subtotal_price / 100,
        parcelCoverSKU = null,
        priceThresholds = Object.keys(_state.dataSource)
          .map((threshold) => +threshold)
          .sort((a, b) => b - a);

      for (var i = 0; i < priceThresholds.length; i++) {
        let priceThreshold = priceThresholds[i];
        if (priceInDollars >= priceThreshold) {
          if (_state.verbose)
            console.debug("User's cart is above", priceThreshold);
          parcelCoverSKU = _state.dataSource[priceThreshold];
          break;
        }
      }

      return parcelCoverSKU;
    };

    function miniCartObserverCallback(mutations) {
      for (const mutation of mutations) {

        if (mutation.attributeName !== "open") return;

        let isOpening = false;
        for (const attr of mutation.target.attributes) {
          if (attr.name === 'open') {
            isOpening = true;
            break;
          }
      }
        
        setTimeout(() => {
          document.querySelector("html").dispatchEvent(new Event(
            isOpening
              ? "ck.parcel-cover.drawer-opened"
              : "ck.parcel-cover.drawer-closed"
          ));
        }, 500);
      }
    }

    function lineItemObserverCallback(mutations) {
      for (const mutation of mutations) {
        console.log(mutations);

        // if (!mutation.target.classList.contains('merge-remove-wrapper')) return;
        if (!mutation.target.classList.contains('cart-item-list__body')) return;

      }

      document.querySelector("body").dispatchEvent(new Event("ck.parcel-cover.drawer-refreshed"));
    }

    function storeState() {
      window.localStorage.setItem(
        _settings.stateKey,
        JSON.stringify({
          coverEnabled: _state.coverEnabled,
          lastCoverPrice: _state.lastCoverPrice,
        })
      );
    }

    this.setupEvents = function () {
      _state.miniCartObserver = new MutationObserver(miniCartObserverCallback);

      _state.miniCartObserver.observe(document.querySelector("cart-drawer"), {
        attributes: true,
        childList: false,
        subtree: false,
      });

      _state.lineItemObserver = new MutationObserver(lineItemObserverCallback);

      _state.lineItemObserver.observe(
        document.querySelector(".cart-item-list.cart-drawer__content-item"),
        {
          attributes: false,
          childList: true,
          subtree: true,
        }
      );

      document.querySelector("html").addEventListener("ck.parcel-cover.drawer-opened", function (e) {
        document.querySelector("body").dispatchEvent(new Event("ck.parcel-cover.drawer-refreshed"));
        __self.silentCartUpdate();
      });

      if (document.querySelectorAll(".cover-toggle-track").length) {
        document.querySelector(".cover-toggle-track").addEventListener("click", function (e) {
          let coverCheckbox = document.getElementById("cover-enabled");

          _state.coverEnabled = !coverCheckbox.checked;

          coverCheckbox.checked = _state.coverEnabled;

          document.querySelector(".parcel-cover__content-wrapper .description").textContent = 
            _state.coverEnabled
              ? _settings.labels.hasParcelCover
              : _settings.labels.noParcelCover
          ;

          __self
            .getCart()
            .then((cart) => {
              if (!_state.coverEnabled)
                return __self.removeAllCover(cart).then(__self.silentCartUpdate);

              return __self.manageParcelCover(cart).then(__self.silentCartUpdate);
            })
            .then(storeState);
        });
      }

      let debouncedCartModified = debounce(function (e, data) {
        if (!_state.coverToggle || !_state.coverToggle.length)
          _state.coverToggle = document.querySelector(".cover-toggle-track");

        if (data.oldCartValue === 0 && data.newCartValue !== 0)
          _state.coverEnabled = true;

        __self.manageParcelCover(data.newCart).then(__self.silentCartUpdate);

        setTimeout(__self.silentCartUpdate, 3000);
      }, 1000);

      document.querySelector("body").addEventListener("ck.parcel-cover.cart-modified", debouncedCartModified);

      document.querySelector("body").addEventListener("ck.parcel-cover.drawer-refreshed", function (e) {

        let coverCheckbox = document.getElementById("cover-enabled");

        coverCheckbox.checked = _state.coverEnabled;

        if (!_state.coverToggle || !_state.coverToggle.length)
          _state.coverToggle = document.querySelector(".cover-toggle-track");

        _state.parcelCoverSKUS.forEach((sku) => {
          const parcelElement = document.querySelector(`.cart-item__quantity-input[data-key^="${sku}"]`);

          if (!parcelElement) return;

          // parcelElement.closest("div[data-merge-list-item]").style.display = 'none';
        });

        document.querySelector(".parcel-cover__content-wrapper .description").textContent =
          _state.coverEnabled
            ? _settings.labels.hasParcelCover
            : _settings.labels.noParcelCover
        ;

        __self
          .getCart()
          .then(async function (cart) {
            if (_state.coverEnabled) await __self.manageParcelCover(cart);
            return cart;
          })
          .then(async function (cart) {
            document.dispatchEvent(new Event('dispatch:cart-drawer:refresh'));

            const sku = await __self.getEligibleCover(cart);
            if (!sku) return __self.removeAllCover();

            let [variantInCart, variants] = __self.variantInCart(sku, cart);
            const coverToggle = document.querySelector(".cover-toggle-track");
            if (coverToggle) {
              if (variantInCart)
                _state.lastCoverPrice = "$".concat(
                  __self.formatPrice(variants[0].price)
                );
              coverToggle.setAttribute(
                "data-val",
                _state.coverEnabled ? _state.lastCoverPrice : ""
              );
            }
          })
          .then(function () {
            storeState();
          });
      });
    };

    function isCartRequest(url) {
      return (
        [
          `/cart/add.js`,
          `/cart/update.js`,
          `/cart/change.js`,
          `/cart/clear`,
        ].filter((path) => url.includes(path)).length !== 0
      );
    }

    function defer(method, selector) {
      if (document.querySelector(selector) !== null) {
          method();
          return false;
      }
      setTimeout(function () {
          defer(method, selector);
      }, 50);
    }

    this.init = function () {
      // Change this to _settings.parcelProtectionSKUs for production use!
      _state.dataSource = _settings.parcelProtectionSKUs;
      _state.parcelCoverSKUS = Object.values(_state.dataSource);

      let existingState = window.localStorage.getItem(_settings.stateKey);

      // Restore state from previous session
      if (existingState) _state = { ..._state, ...JSON.parse(existingState) };

      defer(function () {
        const coverToggle = document.querySelector(".cover-toggle-track");
        if (coverToggle) {
          coverToggle.setAttribute(
            "data-val",
            _state.coverEnabled ? _state.lastCoverPrice : ""
          );
        }
      }, ".cover-toggle-track");

      // Hook jQuery XHR calls
      window.origXHR = XMLHttpRequest;
      var origOpen = window.origXHR.prototype.open;
      window.origXHR.prototype.open = function () {
        this.addEventListener("load", function () {
          if (isCartRequest(this.responseURL)) {
            let responseJSON = null;

            try {
              responseJSON = JSON.parse(this.responseText);
            } catch {}

            if (!responseJSON) return;

            if (this.responseURL.includes("/add.js")) {
              // If we are receiving back an object that has an 'items' property with multiple items, do a full cart refresh
              if (
                responseJSON.hasOwnProperty("items") &&
                responseJSON.items.length > 1
              )
                return;

              let addedItem = responseJSON.hasOwnProperty("items")
                ? responseJSON.items[0]
                : responseJSON;

              if (!addedItem) return;

              let isCoverItem = _state.parcelCoverSKUS.includes(
                addedItem.variant_id.toString()
              );

              if (isCoverItem) return;
            }

            __self.getCart().then(function (cart) {
              var newCart = __self.getRealProductValue(cart);

              if (_state.cachedCartValue === newCart.items_subtotal_price)
                return;
              if (_state.verbose) console.debug("CK - Cart Modified");

              document.querySelector("body").dispatchEvent(new Event("ck.parcel-cover.cart-modified"), {
                  newCart: newCart,
                  oldCartValue: _state.cachedCartValue,
                  newCartValue: newCart.items_subtotal_price,
                });

              _state.cachedCartValue = newCart.items_subtotal_price;
            });
          }
        });
        origOpen.apply(this, arguments);
      };

      __self.getCart().then(function (cart) {
        var newCart = __self.getRealProductValue(cart);
        _state.cachedCartValue = newCart.items_subtotal_price;
      });

      __self.setupEvents();

      storeState();

      return __self;
    };
  };
})();
